import { usePublicOrderWithItems } from "@babackapp/private-api-client/client/use-search-public-order";
import { filterReturnableItems } from "@babackapp/return-widget-components/lib/returnable-items.lib";
import { useParams } from "react-router-dom";
import { useCurrentOrderReturnRequests } from "./return-request";

export function useCurrentOrderLineItems() {
  const { orderId } = useParams();
  return usePublicOrderWithItems(orderId!, {
    select: (data) => data?.lineItems ?? [],
  });
}

export function useCurrentOrderReturnableLineItems() {
  const { data: lineItems = [] } = useCurrentOrderLineItems();
  const { data: returnRequests } = useCurrentOrderReturnRequests();
  return filterReturnableItems(lineItems, returnRequests.returnRequests);
}
